import React, { Children } from 'react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import classNames from 'classnames';

interface Props {
  children: React.ReactNode;
  description: string;
  emptyText?: string;
  headerContent?: React.ReactNode;
  title: string;
  onNext: () => void;
  onPrev: () => void;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  colLayout?: boolean;
}

const ListWrapper = ({
  children,
  description,
  headerContent,
  title,
  onNext,
  onPrev,
  hasNextPage,
  hasPreviousPage,
  emptyText,
  colLayout = false
}: Props) => (
  <div className="flex-1">
    <div className="flex gap-4">
      <h3 className="font-bold text-lg flex-1 text-neutral-800">{title}</h3>
      <button
        className={classNames(
          !hasPreviousPage && 'cursor-not-allowed opacity-50'
        )}
        type="button"
        onClick={onPrev}
        disabled={!hasPreviousPage}
        aria-label="Previous results"
      >
        <MdChevronLeft size={24} />
      </button>
      <button
        className={classNames(!hasNextPage && 'cursor-not-allowed opacity-50')}
        type="button"
        onClick={onNext}
        disabled={!hasNextPage}
        aria-label="Next results"
      >
        <MdChevronRight size={24} />
      </button>
    </div>
    <p className="text-sm font-normal pt-2">{description}</p>
    {headerContent}

    <div className="pt-4 pb-16">
      {Children.count(children) > 0 ? (
        <ul
          className={classNames(
            'flex flex-col gap-4',
            colLayout && 'columns-2 gap-[38px] *:md:pb-4 md:block!'
          )}
        >
          {children}
        </ul>
      ) : (
        <div className="flex flex-1 min-h-28 items-center justify-center font-normal text-base text-neutral-400">
          {emptyText || 'No members'}
        </div>
      )}
    </div>
  </div>
);

export default ListWrapper;
